const uiOptions = {
	wrapperClassName    : 'margin-bottom-15 margin-top-15 flex flex-align-items-center',
	inputGroupClassName : 'flex-3',
	inputClassName      : 'form-control input-border-curve',
	labelFont           : 'flex-2 font-light',
	customMask          : ['0.', /[0-9]/, /\d/, /\d/],
	large               : false,
};

const bankAccountVerificationForm = {
	title  : 'Bank Account Verification Form',
	schema : {
		type       : 'object',
		required   : ['amountOne', 'amountTwo'],
		properties : {
			amountOne : { type : 'string', minLength : 1 },
			amountTwo : { type : 'string', minLength : 1 },
		},
	},
	uiSchema : {
		amountOne : {
			'ui:widget'  : 'textInputMaskedForForms',
			'ui:options' : { ...uiOptions, label : 'First deposit:' },
		},
		amountTwo : {
			'ui:widget'  : 'textInputMaskedForForms',
			'ui:options' : { ...uiOptions, label : 'Second deposit:' },
		},
	},
};

export default bankAccountVerificationForm;
